var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"period"},[_vm._v(_vm._s(_vm.start)+" - "+_vm._s(_vm.end))]),_c('description',{attrs:{"description":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }